<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <template v-if="config_info">
      <transition name="router-fade" mode="out-in">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
      </transition>
      <transition name="router-fade" mode="out-in">
          <router-view v-if="!$route.meta.keepAlive"></router-view>
      </transition>
    </template>
    <template v-else>
      <div class="textW">{{config_info?config_info.close_tips:''}}</div>
    </template>
  </div>
</template>

<script>
import { configResource } from '@/resource/resource'
// import { addCookie, getCookie } from '@/common/js/cookies'
import {mapState, mapMutations} from 'vuex'

const ERR_OK = 0
export default {
  name: 'app',
  created () {
    this.pcOnWap()
    // this.handleCORS()
    this.getNotice()
    // this.launchFullscreen(document.documentElement)
  },
  mounted () {
    try {
      document.body.removeChild(document.getElementById('app-loader'))
    } catch (e) {}
    if (process.env.siteName === 'aomenbaijiale') {
      this.aomenbaijiale()
    }
  },
  computed: {
    ...mapState(['config_info'])
  },
  methods: {
    aomenbaijiale () {
        var hm = document.createElement('script')
        hm.src = 'https://hm.baidu.com/hm.js?d0e2586c0d8ce5c36e1996f1fab2b15e'
        var s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(hm, s)
    },
    // 获取横幅公告
    getNotice () {
      // indexResource.config().then(response => {
      //   response = response.body
      //   if (response.errcode === 0) {
      //     this.CONFIG_INFO(response.data)
      //     document.title = response.data.home_title
      //     if (response.data.site_open === '0') {
      //       this.$messagebox.alert(response.data.close_tips, '通知')
      //     }
      //   }
      // })
      configResource.config({ config: 'sale_extend,site_icon,site_title,site_notice,site_copyright,service_macao_number,service_philippines_number,service_qq,service_wechat,banner_main,link_main,search_vip,search_e_level,search_r_level,search_price,search_e_up_reward,search_e_week_reward,search_e_month_reward,search_r_up_reward,search_r_month_reward,service_buy,service_repwd_url,service_main_sell_limit,service_sell_limit,service_hot_limit,service_sold_limit,credit_url,wap_logo,wap_title,wap_credit_url,week_salary_status,month_salary_status,finance_salary_status' }).then(response => {
        response = response.body
        if (response.errcode === ERR_OK) {
          this.CONFIG_INFO(response.data)
          // this.CONFIG_FOOT(response.foot)
          this.getFavicon(response.data.site_icon)
          document.title = response.data.site_title
          localStorage.setItem('sale_extend', response.data.sale_extend)
        }
      })
    },
    pcOnWap() {
      // console.log(window.location.pathname, window.location.search, window.location.host)
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(window.navigator.userAgent)) {
      } else {
        if (window.location.host.includes('m') && !window.location.host.indexOf('m')) {
          window.location.href = '//' + window.location.host.replace('m', 'www')
        }
        // this.showPC = true
      }
    },
    // ios浏览器跨域访问
    // handleCORS() {
    //   let u = window.navigator.userAgent
    //   let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // 是否ios终端
    //   if (isiOS) {
    //     if (!getCookie('auth')) { // 24小时内只需执行一次
    //       let localUrl = window.location.host
    //       let localApi = window.apiUrl
    //       let localUrlArr = localUrl.split('.')
    //       let localApiArr = localApi.split('.')
    //       let uLength = localUrlArr.length
    //       let aLength = localApiArr.length
    //       let isEq = uLength >= 2 && aLength >= 2 && localUrlArr[uLength - 2] === localApiArr[aLength - 2] // 是否相同的一级域名
    //       if (!isEq) { // ios浏览器跨域访问，则解决ios浏览器不带cookie问题
    //         addCookie('auth', true, 24)
    //         window.location.href = window.apiUrl + '/go.php'
    //       }
    //     }
    //   }
    // },
    getFavicon(url) {
      var link = document.createElement('link')
      link.href = url
      link.rel = 'shortcut icon'
      document.head.appendChild(link)
    },
    // 更新vuex状态信息
    ...mapMutations([
      'CONFIG_INFO'
    ])
    // launchFullscreen (element) {
    //   if (element.requestFullscreen) {
    //     element.requestFullscreen()
    //   } else if (element.mozRequestFullScreen) {
    //     element.mozRequestFullScreen()
    //   } else if (element.webkitRequestFullscreen) {
    //     element.webkitRequestFullscreen()
    //   } else if (element.msRequestFullscreen) {
    //     element.msRequestFullscreen()
    //   }
    // }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  #app
    font-family: 'PingFang SC', 'STHeitiSC-Light', 'Helvetica-Light', arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  .router-fade-enter-active, .router-fade-leave-active
    transition: opacity .3s
  .router-fade-enter, .router-fade-leave-active
    opacity: 0
  .textW
    font-size $font-size-m
</style>



// WEBPACK FOOTER //
// src/App.vue